module.exports = __webpack_public_path__ + "img/Assurance-Extra-Premium.f18f26f6.jpg";